import styled from "styled-components";

export const AboutContainer = styled.div`
  line-height: 3vh;
  display: flex;

  @media screen and (max-width: 700px) {
    display: block;
    img {
      float: left;
      margin-right: 20px;
      margin-bottom: 10px;
      width: 50%;
    }
  }
`;

export const AboutText = styled.div`
  margin-left: 0px;

  @media screen and (min-width: 700px) {
    margin-left: 10px;
  }

  flex: 1;
`;
